import { Component } from 'react';
import { getLocale } from 'core/i18n/localeStore';
import { translate } from 'core/i18n/messages';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      const t = (key) => this.props.t?.(key) || translate(getLocale(), key);
      return (
        <div className="error-state" role="alert">
          <p>{this.props.fallback || t('errors.unexpected')}</p>
          <button type="button" className="btn btn-secondary" onClick={() => this.setState({ hasError: false })}>
            {this.props.retryLabel || t('actions.retry')}
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
